// Imports
import Panzoom from '@panzoom/panzoom';

// Project imports
import Modal from '@js/modules/Modal';

class FloorplansMap {
    constructor() {}

    init() {
        const mapPanZoomEl = document.querySelector('.map-pan-zoom');

        if (mapPanZoomEl) {
            const parentEl = mapPanZoomEl.parentElement;
            const mapZoomInBtn = document.querySelector('.map-pan-zoom-in');
            const mapZoomOutBtn = document.querySelector('.map-pan-zoom-out');
            let panzoom = null;

            panzoom = Panzoom(mapPanZoomEl, {
                contain: 'outside',
                maxScale: 4,
                minScale: 1,
            });

            setTimeout(() => {
                this._centerImage(panzoom, mapPanZoomEl);
            }, 200);

            // Bind to shift+mousewheel
            parentEl.addEventListener('wheel', function (event) {
                if (!event.shiftKey) {
                    return;
                }

                if (panzoom) {
                    // Panzoom will automatically use `deltaX` here instead
                    // of `deltaY`. On a mac, the shift modifier usually
                    // translates to horizontal scrolling, but Panzoom assumes
                    // the desired behavior is zooming.
                    panzoom.zoomWithWheel(event);
                }
            });

            if (mapZoomInBtn) {
                mapZoomInBtn.addEventListener('click', panzoom.zoomIn);
            }
            if (mapZoomOutBtn) {
                mapZoomOutBtn.addEventListener('click', panzoom.zoomOut);
            }

            window.addEventListener('resize', () => {
                if (panzoom) {
                    panzoom.reset({animate: false});
                }

                setTimeout(() => {
                    this._centerImage(panzoom, mapPanZoomEl);
                }, 200);
            });
        }

        this.floorPlans = document.querySelector('.floor-plans'); // Main container

        if (this.floorPlans) {
            let floorplansJson = this.floorPlans.getAttribute('data-floorplans');
            // Convert the string to JSON
            floorplansJson = JSON.parse(floorplansJson);
            console.log({floorplansJson});

            if (typeof floorplansJson !== 'undefined' && floorplansJson) {
                this.selectedClass = 'selected';
                this.floorPlansLayouts = document.querySelector('.floor-plans-layouts'); // Main container
                this.floorPlansImages = document.querySelector('.floor-plans-images');

                // Only create tooltip if it doesn't already exist
                let tooltip = document.querySelector('.floor-plans-tooltip');
                if (!tooltip) {
                    tooltip = document.createElement('div');
                    tooltip.className = 'floor-plans-tooltip';
                    document.body.appendChild(tooltip);
                }

                // Only create slide panel if it doesn't already exist
                let slidePanel = document.querySelector('.floor-plans-slide-panel');
                if (!slidePanel) {
                    slidePanel = document.createElement('div');
                    slidePanel.className = 'floor-plans-slide-panel';
                    slidePanel.innerHTML = `
                        <div class="floor-plans-slide-panel-content">
                            <button class="floor-plans-slide-panel-close-btn link _icon-left exclude-active">
                                <span class="link-text order-2">Back</span>
               
                                <div class="arrow-container order-1" aria-hidden="true">
                                    <div class="arrows">
                                        <div class="arrow">
                                            <svg class="icon-arrow-lg-w " fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12">
                                                <path d="m0 6 6 6h1.77L2.39 6.62H18V5.38H2.39L7.77 0H6L0 6Z"></path>
                                            </svg>
                                        </div>
                                        <div class="arrow">
                                            <svg class="icon-arrow-lg-w " fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12">
                                                <path d="m0 6 6 6h1.77L2.39 6.62H18V5.38H2.39L7.77 0H6L0 6Z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </button>
                            
                            <div class="floor-plans-slide-panel-body"></div>
                        </div>
                    `;

                    // Add slide panel to DOM
                    document.body.appendChild(slidePanel);
                }

                const slideBody = slidePanel.querySelector('.floor-plans-slide-panel-body');
                const closeBtn = slidePanel.querySelector('.floor-plans-slide-panel-close-btn');

                // Function to show tooltip
                function showTooltip(event, apartment) {
                    tooltip.innerHTML = `
                        <div class="floor-plans-tooltip-heading">${apartment.apartmentTitle}</div>
                        <div class="floor-plans-tooltip-content">
                            ${apartment.bedBaths}<br>
                            ${apartment.renovated ? `Renovated Unit<br>` : ''}
                            Rent: ${apartment.rent}
                        </div>
                    `;
                    tooltip.style.display = 'block';
                    moveTooltip(event);
                }

                // Function to move tooltip
                function moveTooltip(event) {
                    tooltip.style.left = `${event.pageX + 10}px`;
                    tooltip.style.top = `${event.pageY + 10}px`;
                }

                // Function to hide tooltip
                function hideTooltip() {
                    tooltip.style.display = 'none';
                }

                // Function to load content into slide panel
                async function loadApartmentDetails(url) {
                    slideBody.innerHTML = '<div class="flex items-center justify-center h-full w-full text-accent"><div class="spinner"></div></div>';

                    try {
                        const response = await fetch(url);
                        const html = await response.text();
                        slideBody.innerHTML = html;

                        Modal.init();
                    } catch (error) {
                        slideBody.innerHTML = '<p>Error loading details. Please try again.</p>';
                    }
                }

                // Function to open slide panel
                const openSlidePanel = (el, apartment) => {
                    // If element is already selected, don't do anything
                    if (el.classList.contains(this.selectedClass)) {
                        return;
                    }

                    // Remove active state on currently selected unit - if any
                    let selectedUnit = this.floorPlans.querySelector('.' + this.selectedClass);
                    if (selectedUnit) {
                        this.floorPlans.querySelector('.' + this.selectedClass).classList.remove(this.selectedClass);
                    }

                    // Select unit
                    el.classList.add(this.selectedClass);

                    loadApartmentDetails(apartment.url);
                    slidePanel.classList.add('open');

                    // Scroll to top of layout
                    //ScrollTo.scrollTo('.floor-plans-layouts');
                };

                // Function to close slide panel
                const closeSlidePanel = () => {
                    // Unselect unit
                    this.floorPlans.querySelector('.' + this.selectedClass).classList.remove(this.selectedClass);

                    slidePanel.classList.remove('open');
                };

                // Remove old results
                document.querySelectorAll('[id*="unit-"].active').forEach(el => {
                    el.classList.remove('active', 'special');

                    // Mouse enter - Show tooltip
                    el.removeEventListener('mouseenter', showTooltip);

                    // Mouse move - Move tooltip
                    el.removeEventListener('mousemove', moveTooltip);

                    // Mouse leave - Hide tooltip
                    el.removeEventListener('mouseleave', hideTooltip);

                    // Click - Open slide panel
                    el.removeEventListener('click', openSlidePanel);
                });

                // Attach event listeners to unit elements
                Object.values(floorplansJson).forEach(apartmentList => {
                    apartmentList.forEach(apartment => {
                        const apartmentId = `unit-${apartment.apartmentTitle.toLowerCase()}`;
                        const elementMobile = document.getElementById('mobile-' + apartmentId);
                        const element = document.getElementById(apartmentId);

                        if (elementMobile) {
                            elementMobile.classList.add('active');

                            // Is element special (Renovated)
                            if (apartment.renovated) {
                                elementMobile.classList.add('special');
                            }

                            // Mouse enter - Show tooltip
                            elementMobile.addEventListener('mouseenter', (event) => showTooltip(event, apartment));

                            // Mouse move - Move tooltip
                            elementMobile.addEventListener('mousemove', moveTooltip);

                            // Mouse leave - Hide tooltip
                            elementMobile.addEventListener('mouseleave', hideTooltip);

                            // Click - Open slide panel
                            elementMobile.addEventListener('click', () => openSlidePanel(elementMobile, apartment));
                        }

                        if (element) {
                            element.classList.add('active');

                            // Is element special (Renovated)
                            if (apartment.renovated) {
                                element.classList.add('special');
                            }

                            // Mouse enter - Show tooltip
                            element.addEventListener('mouseenter', (event) => showTooltip(event, apartment));

                            // Mouse move - Move tooltip
                            element.addEventListener('mousemove', moveTooltip);

                            // Mouse leave - Hide tooltip
                            element.addEventListener('mouseleave', hideTooltip);

                            // Click - Open slide panel
                            element.addEventListener('click', () => openSlidePanel(element, apartment));
                        }
                    });
                });

                // Close panel event listeners
                closeBtn.addEventListener('click', closeSlidePanel);
                document.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape') {
                        closeSlidePanel();
                    }
                });
            }
        }
    }
    _centerImage(panzoomInstance, image) {
        const container = image.parentElement;
        const parentWidth = container.offsetWidth;
        const parentHeight = container.offsetHeight;

        const imageWidth = image.offsetWidth;
        const imageHeight = image.offsetHeight;

        const x = (parentWidth - imageWidth) / 2;
        const y = (parentHeight - imageHeight) / 2;

        panzoomInstance.pan(x, y);
    }
}

export default new FloorplansMap();
